export function throttle(fn: any, delay: number) {
  let timer: any;
  return function() {
    if(!timer) {
      // @ts-ignore
      const self: any = this;
      fn.apply(self, ...arguments)
      timer = setTimeout(()=>{
        clearTimeout(timer);
        timer = null;
      }, delay);
    }
  }
}
